<template>
    <div class="news-items" v-if="newsItems != null">
        <div class="news-item" v-for="item in newsItems">
            <!-- :class="{animate : newsCardAnimate}" -->
            <!-- :to="'/news/' + cytTolat(item.title)" -->
            <router-link :to="{ name: 'news-card' , params:{'id' : item.slug}}">
                <div class="news-item-img" :style="!isMobileChecker ? 'background-image: url(' + item.img_prev + ')' : 'background-image: url(' + item.img_prev_mobile + ')'"></div>
                <div class="news-date">
                    <span>{{correctDate(item.date)}}</span>
                </div>
                <div class="news-title">
                    <strong v-html="item.title"></strong>
                </div>
                <div class="btn-more btn-wow-effect-hover">
                    <span v-if="globalLang == ''">Подробнее</span>
                    <span v-if="globalLang == 'kz/'">Толығырақ</span>
                    <svgIcon name="arrow-right" class="icon-right-arrow"/>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
    // var convert = require('cyrillic-to-latin');
    var cyrillicToTranslit = require("cyrillic-to-translit-js")
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'news-item',
        props: ['newsItems'],
        components: {
            svgIcon,
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                globalLang: window.GlobalLang,
            }
        },
        methods: {
            cytTolat(text) {
                return cyrillicToTranslit().transform(text, "_").replace(/!/g,'').replace(/:/g,'').replace(/–/g,'').replace(/-/g,'').replace(/«/g,'').replace(/»/g,'').replace(/,/g,'').toLowerCase();
            },
            correctDate(date) {
                var day = parseFloat(date.slice(8, 10));
                var month = date.slice(5, 7);
                var year = date.slice(0, 4);
                var monthFont;
                var total;
                var monthNames = {
                    '01': { 'kz/': 'Қаңтар', 'en/': 'January', 'default': 'Января' },
                    '02': { 'kz/': 'Ақпан', 'en/': 'February', 'default': 'Февраля' },
                    '03': { 'kz/': 'Наурыз', 'en/': 'March', 'default': 'Марта' },
                    '04': { 'kz/': 'Сәуiр', 'en/': 'April', 'default': 'Апреля' },
                    '05': { 'kz/': 'Мамыр', 'en/': 'May', 'default': 'Мая' },
                    '06': { 'kz/': 'Маусым', 'en/': 'June', 'default': 'Июня' },
                    '07': { 'kz/': 'Шiлде', 'en/': 'July', 'default': 'Июля' },
                    '08': { 'kz/': 'Тамыз', 'en/': 'August', 'default': 'Августа' },
                    '09': { 'kz/': 'Қыркүйек', 'en/': 'September', 'default': 'Сентября' },
                    '10': { 'kz/': 'Қазан', 'en/': 'October', 'default': 'Октября' },
                    '11': { 'kz/': 'Қараша', 'en/': 'November', 'default': 'Ноября' },
                    '12': { 'kz/': 'Желтоқсан', 'en/': 'December', 'default': 'Декабря' }
                };
                monthFont = monthNames[month] ? monthNames[month][this.globalLang] || monthNames[month]['default'] : '';
                total = day + ' ' + monthFont + ' ' + year;
                return total;
            },
            setFilterNewsLength() {
                if (this.routerName != 'home') {
                    this.$store.commit('filterNewsItems', this.newsItemsDefault);
                }
            },
            startLoader() {
                if (this.routerName == 'home') {
                    this.$parent.$parent.$parent.$refs.topProgress.start();
                } else  {
                    this.$parent.$parent.$refs.topProgress.start();
                }
            }
        },
        computed: mapGetters({
            isMobileChecker: 'loadIsMobileChecker',
        }),
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            // this.setFilterNewsLength();
            // this.$store.watch(
            //     (state) => state.newsItemsFilter,
            //     (newValue) => {
            //         if (newValue) {
            //             this.setFilterNewsLength();
            //         }
            //     }
            // )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/news-page/news-item.scss';
    @import '@/styles/components/news-page/respond/news-item-respond.scss';
    // @import '@/styles/respond/news/news-item-respond.scss';
</style>